import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "@/components/ui/dialog";
import { deleteReport } from "@/lib/api";
import { toast } from "sonner";

export default function DeleteReportDialog({ report, onClose, onDeleted }) {
    const [busy, setBusy] = useState(false);
    const open = !!report;

    const confirm = async () => {
        if (!report) return;
        try {
            setBusy(true);
            await deleteReport(report.report_id);
            toast.success("Report deleted");
            onDeleted?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Could not delete report.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={(v) => !v && !busy && onClose?.()}>
            <DialogContent
                className="max-w-md bg-bl-surface border-bl rounded-2xl"
                data-testid="delete-report-dialog"
            >
                <DialogHeader>
                    <div className="bl-eyebrow w-fit">Delete report</div>
                    <DialogTitle className="font-display text-2xl text-bl mt-2">
                        Delete this report?
                    </DialogTitle>
                    <DialogDescription className="text-bl-muted">
                        This will remove{" "}
                        <span className="text-bl">
                            {report?.property_address || "this report"}
                        </span>{" "}
                        from your dashboard and delete the stored report
                        analysis associated with it. Your purchase record is
                        preserved.{" "}
                        <span className="text-bl">This action cannot be undone.</span>
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-2 flex flex-row gap-3 justify-end">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={busy}
                        className="bl-btn-secondary"
                        data-testid="delete-report-cancel-btn"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={confirm}
                        disabled={busy}
                        className="bl-btn-danger"
                        data-testid="delete-report-confirm-btn"
                    >
                        {busy ? "Deleting…" : "Delete Report"}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
